export const USER_ID_KEY = 'USER_ID';

export const PAYMENTS_METHODS = ['EURO', 'USD'];

export const TACLIA_LOGO_URL = 'https://cdn.taclia.com/images/logo/transparent/taclia_blue.png';
